import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { PermissionEnum } from '../models/permissions-enum.model';
import { map, take } from 'rxjs/operators';

export const hasPermissionGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const requiredPermissions = route.data['requiredPermissions'] as PermissionEnum | PermissionEnum[];
  const requireAll = route.data['requireAll'] as boolean ?? false;

  const checkPermissions = (permissions: PermissionEnum | PermissionEnum[], requireAllPermissions: boolean): boolean => {
    if (Array.isArray(permissions)) {
      return requireAllPermissions
        ? permissions.every(permission => auth.hasPermission(permission))
        : permissions.some(permission => auth.hasPermission(permission));
    } else {
      return auth.hasPermission(permissions);
    }
  };

  return auth.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      if (!isAuthenticated) {
        return router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url }
        });
      }

      if (requiredPermissions && !checkPermissions(requiredPermissions, requireAll)) {
        return router.createUrlTree(['/unauthorized']);
      }

      return true;
    })
  );
};